export default "__VITE_ASSET__n$jlzKUw__"